export const warningColors = {
  'acreage-gis-value-breach': '#FFD9BE',
  'acreage-factor-total-breach': '#FFB784',
  'acreage-value-total-breach': '#FFF2E8',
  'lateral-factor-total-breach': '#F1C21B',
  'lateral-value-total-breach': '#FDDC69',
  'lateral-gis-value-breach': '#FCF4D6',
};

// Type for the warning colors to ensure type safety
export type WarningId = keyof typeof warningColors;
